import { cardBelongsToCatalogGroup } from './accessUtils';

/** Ids próprios do doc (sem equivalentIds) — fingerprint do conteúdo configurado. */
export function getCatalogOwnGroup(product) {
  if (product?.ownIds?.length) return product.ownIds;
  if (product?.productId && product?.type) {
    return [{ id: product.productId, type: product.type }];
  }
  return [];
}

/**
 * Assinatura estável do conteúdo vinculado (categoria + módulo) para comparar
 * se dois produtos de vitrine liberam exatamente o mesmo conteúdo.
 */
export function getCatalogContentSignature(product, categories = []) {
  const group = getCatalogOwnGroup(product);
  if (!group.length) return '';

  const entries = (categories || []).flatMap((category) =>
    (category.cards || [])
      .filter((card) => cardBelongsToCatalogGroup(card, group))
      .map((card) => `${category.id}:${card.id}`)
  );

  return entries.sort().join(',');
}

export function hasSameCatalogContent(productA, productB, categories = []) {
  if (!productA || !productB) return false;
  return (
    getCatalogContentSignature(productA, categories) ===
    getCatalogContentSignature(productB, categories)
  );
}

/** Outros itens elegíveis como equivalentes (mesmo conteúdo ou já selecionados). */
export function getCatalogEquivalentCandidates(
  selfProduct,
  catalogProducts = [],
  categories = [],
  { selfId, selectedIds = [] } = {}
) {
  const selectedSet = new Set(selectedIds);
  const selfSignature = selfProduct ? getCatalogContentSignature(selfProduct, categories) : '';

  return (catalogProducts || [])
    .filter((item) => item.id !== selfId)
    .filter((item) => {
      if (selectedSet.has(item.id)) return true;
      if (!selfSignature) return false;
      return hasSameCatalogContent(selfProduct, item, categories);
    });
}

/** Há outros itens com exatamente o mesmo conteúdo vinculado. */
export function hasCatalogEquivalentMatches(
  selfProduct,
  catalogProducts = [],
  categories = [],
  selfId
) {
  if (!selfProduct) return false;

  const selfSignature = getCatalogContentSignature(selfProduct, categories);
  if (!selfSignature) return false;

  return (catalogProducts || []).some(
    (item) => item.id !== selfId && hasSameCatalogContent(selfProduct, item, categories)
  );
}

/** Equivalentes inválidos (conteúdo diferente ou produto sem módulos vinculados). */
export function getInvalidCatalogEquivalents(selfProduct, equivalentIds = [], catalogProducts = [], categories = []) {
  if (!selfProduct) return [];

  const selfSignature = getCatalogContentSignature(selfProduct, categories);
  if (!selfSignature) {
    return equivalentIds;
  }

  const byId = new Map((catalogProducts || []).map((item) => [item.id, item]));

  return (equivalentIds || []).filter((eq) => {
    const candidate = byId.get(eq.id);
    if (!candidate) return true;
    return !hasSameCatalogContent(selfProduct, candidate, categories);
  });
}
